import { render } from "./ModelStats.vue?vue&type=template&id=36d8e586"
import script from "./ModelStats.vue?vue&type=script&lang=js"
export * from "./ModelStats.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__